import { StaticImage } from "gatsby-plugin-image"

import { blogUrl } from "../../services/blogLinks"

const hclData = {
  color: "#c6c3ff",
  heroTitle: `How HCL Tech enabled seamless photo sharing—without collecting PII`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/hcl/hcl-hero.png"
      alt="hcl-technologies-enterprise-event-photo-ai-hero"
    />
  ),
  metrics: {
    quote: `
      Table of Contents<br/><br/>
      <ul style="list-style-type: disc; padding: 0 60px; text-align: left;">
        <li style="margin-bottom: 16px;"><a href='#section-0'>The challenge: Privacy-first photo sharing</a></li>
        <li style="margin-bottom: 16px;"><a href='#section-1'>The solution: A secure, no-data, no-hassle photo distribution platform</a></li>
        <li style="margin-bottom: 16px;"><a href='#section-2'>The result: Trusted across 10+ global events (and counting)</a></li>
        <li class='mb-2'><a href='#section-3'>The Premagic impact on small-format events</a></li>
        <li class='mb-2'><a href='#section-4'>Why Premagic works for small, high-impact events</a></li>
      </ul>`,
  },
  images: [
    {
      // img: <StaticImage src="" />
    },
    {
      // img: <StaticImage src="" />
    },
  ],
  gallery: "",
  caseStudyData: [
    {
      title: "The challenge: Privacy-first photo sharing",
      info1: `HCL Tech is a leading global technology company with a consolidated revenue of $13.8 billion and a market capitalization of $52.2 billion. Powered by a global team of 220,000+ diverse professionals across 60 countries, HCL delivers IT services, digital transformation solutions, and engineering capabilities to enterprises across industries. <br/><br/>The HCL Group runs multiple internal and client-facing events across Japan, Singapore, Europe, and India - almost every month. These events often include senior leadership and global clients, making attendee experience a high priority. One of the key upgrades to the attendee experience they were exploring was <a href='https://premagic.com/smart-photo-distribution-for-seamless-events/'>AI-powered photo distribution</a>. <br/><br/>The HCL team had first experienced Premagic at one of their events managed by an event agency. The seamless execution caught the attention of HCL’s global marketing team, who then reached out to collaborate with us directly.<br/><br/>However, they had one non-negotiable:<b> no attendee data could leave their ecosystem.</b> <br/><br/>They needed a way to share event photos without asking for or storing any personally identifiable information (PII). No third-party access. No cloud storage of names, emails, or phone numbers. <br/><br/>The goal was to maintain the trust and discretion their high-profile attendees expected, especially since many of these were internal meetings, board sessions, and client gatherings.`,
      // testimonial: {
      //   img: (
      //     <StaticImage src="../../images/case-study/idc/avatar.jpeg" alt="" />
      //   ),
      //   message: `“IDC came in with a clear goal. They wanted engagement that felt organic, not forced. Once they saw how Premagic could blend creativity with automation, the hesitation disappeared.“`,
      //   name: "Bhakti Kapasi",
      //   info: `Account Executive,<br/> Premagic`,
      // },
      // inlineLink: {
      //   text: 'BREAKING STEREOTYPES AT THE BANKNOTE CONFERENCE',
      //   link: 'https://premagic.com/case-study/currency-research',
      // }
    },
    {
      title:
        "The solution: A secure, no-data, no-hassle photo distribution platform",
      info1: `That’s where Premagic came in. <br/><br/>We offered HCL a privacy-first alternative: a <b>guest gallery link.</b> This QR-code-enabled system required zero data from attendees. The attendees could just scan their faces with a selfie and get their photos. The selfies are deleted soon after and not stored within our system. No selfies, registrations, names or phone numbers. The whole thing is completely PII-free!<br/><br/>Just a clean, HCL Tech-branded interface where guests could instantly access their photos from the event the moment they were uploaded.<br/><br/>It felt native and premium. And most importantly, it met their privacy standards.<br/>`,
    },
    // {
    //   title: 'Features Used:',
    //   info1: `<ul style="list-style-type: disc; padding-left: 20px">
    //   <li class='mb-2'><a href='https://premagic.com/smart-photo-distribution-for-seamless-events/'>AI-powered Photo Distribution</a></li>
    //   <li class='mb-2'><a href='https://premagic.com/event-networking-app/'>Networking Module (Ripple)</a></li>
    //   <li class='mb-2'><a href='https://premagic.com/sponsored-content/'>Sponsor Watermark Module</a></li>
    //   <li class='mb-2'><a href='javascript:void(0)'>Digital Asset Management</a></li>
    //   <li class='mb-2'><a href='https://blog.premagic.com/sparks/'>Sparks - Event Memories</a></li>
    //   <li class='mb-2'><a href='javascript:void(0)'>White-labeled platform for all event touchpoints</a></li>
    //   <li class='mb-2'><a href='javascript:void(0)'>Post-event analytics and reporting</a></li>
    //   <li class='mb-2'><a href='javascript:void(0)'>Designated CXM for event setup with extensive support (24/7 phone, chats, and emails)</a></li>

    //   </ul>`,
    //   info2: ``,

    //   gridViewTitle: 'Key Features That Made It Work',
    //   inlineLink: {
    //     text: 'RETHINKING I-AM-ATTENDING POSTERS FOR SAASBOOMI ANNUAL 2025',
    //     link: 'https://blog.premagic.com/rethinking-i-am-attending-posters-for-saasboomi-annual-2025/',
    //   },
    // },
    {
      title: "The results: Trusted by HCL across 10+ events and counting",
      info1: `Since October 2024, HCL has used Premagic at <b>more than 10+ events</b> across India, Japan, Singapore, and Europe. The adoption has been fast and consistent.<br/><br/>At Premagic, we take their security needs seriously, and every deployment is designed with <b>data protection</b> and <b>privacy compliance</b> at the core, so HCL never has to worry about compromising attendee trust.<br/><br/>They now use Premagic almost every month, not just for events but also for <b>town halls, advisory board meetings, confidential leadership huddles, and internal celebrations.</b> `,
      inlineLink: {
        text: "BREAKING STEREOTYPES AT THE BANKNOTE CONFERENCE",
        link: "https://premagic.com/case-study/currency-research",
      },
      // image: <StaticImage src="../../images/case-study/ifeat/banner2.jpeg" alt="Impact" />,
    },
    {
      title: "The Premagic impact on small-format events",
      info1: `Premagic is built to work seamlessly across all event sizes and formats. From large-scale conferences to smaller, high-impact gatherings, it adapts to the needs of every kind of event, just like it did for HCL.<br/><br/>
      It delivers powerful results at small-format, high-stakes gatherings, where every attendee matters and the experience needs to be seamless.<br/><br/>
      Here’s how Premagic fits into intimate, private settings:<br/><br/>
      <ul class='pl-4 list-disc space-y-4'>
        <li><b>Board meetings</b> where discretion and data control are critical.</li>
        <li><b>Town halls</b> where speed and ease of access matter.</li>
        <li><b>Advisory forums and client conclaves</b> where experience and branding take center stage.</li>
        <li><b>Awards nights and press tours</b> where visibility is high, but privacy still matters.</li>
      </ul>
      <br/>And it works without any trade-offs.`,
      inlineLink: {
        text: "HOW IDC USED PHOTOS, POSTERS AND AVATARS TO DRIVE SOCIAL SHARING",
        link: "https://premagic.com/case-study/idc/",
      },
    },
    {
      title: "Why it works for small, privacy-sensitive events",
      info1: `
      <b>Delivers a premium experience for top-tier attendees</b><br/>
      From CXOs to global clients, it ensures every guest feels considered and valued, without compromising on privacy or convenience.<br/><br/>
    
      <b>No attendee data required</b><br/>
      Attendees don’t need to register or share contact info, making it perfect for confidential or internal gatherings.<br/><br/>
    
      <b>Instantly shareable galleries</b><br/>
      Event teams can <a href='${blogUrl("photoDistribution")}'>share photos</a> in real time via a secure link, without manual sorting or follow-ups.<br/><br/>
    
      <b>Clean, branded delivery</b><br/>
      Despite the simplicity, the experience still feels polished and on-brand that is ideal for events with senior stakeholders or high-profile guests.<br/><br/>
    
      <b>Designed for smaller groups</b><br/>
      Whether it's 20 or 100 people, Premagic scales beautifully for events where personal touch matters more than volume.<br/><br/>
    
      <b>Built with enterprise-grade privacy in mind</b><br/>
      With no third-party data sharing, no storage of PII, and full organizer control, it meets the compliance needs of even the most security-conscious teams.<br/><br/>
    
      HCL’s journey with Premagic proves that the right event tech can turn even the smallest gathering into a premium experience. With every board meeting, town hall, and client conclave, HCL transformed internal events into high-engagement moments that their attendees noticed and remembered.<br/><br/>Planning a private event and want to deliver a high-touch experience, without the privacy risks?
      `,
    },
  ],
  isCTAActive: true,
}

export default hclData
